export default __webpack_public_path__ + "static/media/title-winners_th.26295d98.png";